import { render } from "./Workadd.vue?vue&type=template&id=2a0eb622"
import script from "./Workadd.vue?vue&type=script&lang=js"
export * from "./Workadd.vue?vue&type=script&lang=js"

import "./Workadd.vue?vue&type=style&index=0&id=2a0eb622&lang=css"

import exportComponent from "E:\\claude\\match\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__